export default __webpack_public_path__ + "static/media/news-image-3.76aa5a03.png";